import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add interceptor to include current organization context in all requests
axiosInstance.interceptors.request.use(
  (config) => {
    // Get current organization UUID from localStorage (set by OrganizationContext)
    const currentOrgUuid = localStorage.getItem('currentOrganizationUuid');
    if (currentOrgUuid) {
      config.headers['X-Organization-Uuid'] = currentOrgUuid;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
